import React from 'react'
import { FormattedMessage } from 'react-intl'
import { connect } from 'react-redux'
import { UserOutlined } from '@ant-design/icons'
import { Avatar, Dropdown, Menu, Modal, Tag } from 'antd'
import { Link } from 'react-router-dom'
import { logout } from 'services/user'
import actions from 'redux/user/actions'
import styles from './style.module.scss'
import setLogoutSucess from '../../../../../pages/inbox/SMSClient/LogoutInformer'

const mapStateToProps = ({ user, subscription, settings }) => ({
  user,
  subscription: subscription.data,
  isMenuCollapsed: settings.isMenuCollapsed,
})

const { confirm } = Modal

const ProfileMenu = ({ dispatch, user, subscription, isMenuCollapsed }) => {
  // const smsClient = useRef()
  let status
  let statusColor = '#3b88c3'
  if (subscription?.primary_billing_method === 'Clover') {
    status = subscription?.clover?.status
  } else if (subscription?.primary_billing_method === 'Stripe') {
    status = subscription?.stripe?.status
  } else if (subscription?.primary_billing_method === 'Shopify') {
    status = subscription?.shopify?.status
  }
  if (status?.toLowerCase().includes('active')) {
    statusColor = '#41b883'
  } else if (status?.toLowerCase().includes('trial')) {
    if (status === 'trialing') {
      status = 'trial'
    }
    statusColor = '#faad15'
  }

  const onLogout = e => {
    e.preventDefault()
    confirm({
      title: 'Are you sure you want to logout?',
      onOk: () => {
        //        smsClient.current.UserLoggedOut()
        setLogoutSucess()
        return logout().then(() => {
          // smsClient.current.ReloadSocketConnection()
          dispatch({
            type: actions.LOGOUT,
          })
          return false
        })
      },
      okText: 'Yes, Go ahead',
      cancelText: 'No',
    })
  }

  const menu = (
    <Menu selectable={false} style={{ padding: '10px' }}>
      <Menu.Item style={{ paddingBottom: '12px' }}>
        <Link to="/change-password">
          <i className="fe fe-user mr-2" />
          <FormattedMessage id="topBar.profileMenu.changePassword" />
        </Link>
      </Menu.Item>
      <Menu.Item>
        <a href="#" onClick={onLogout}>
          <i className="fe fe-log-out mr-2" />
          <FormattedMessage id="topBar.profileMenu.logout" />
        </a>
      </Menu.Item>
    </Menu>
  )
  return (
    <>
      <Dropdown overlay={menu} trigger={['hover']} placement="topCenter">
        <div className={styles.dropdown}>
          <Avatar className={styles.avatar} shape="circle" size="large" icon={<UserOutlined />} />
          <span
            className={[isMenuCollapsed ? 'hide' : '', 'show-mobile'].join(' ')}
            style={{ paddingLeft: '12px' }}
          >
            {user.business?.name}
            <div className="font-size-12 text-secondary">({user.name})</div>
            <div className="text-capitalize">
              {status && <Tag color={statusColor}>{status}</Tag>}
            </div>
          </span>
        </div>
      </Dropdown>
      <div style={{ display: 'none' }}>SMSClient</div>
    </>
  )
}

export default connect(mapStateToProps)(ProfileMenu)
